import React from "react";
import { Row, Col } from 'react-bootstrap';
import { IAminityData } from "../../types/api/aminityApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { ISubAminity } from "../../types/features/multiLanguageSlice";
// import { Link } from "react-router-dom";
const AmenitiesSection2: React.FC<{ aminities: Array<IAminityData> }> = ({ aminities }) => {
    const {t} = useTranslation()
    const aminity_json = t('aminity.aminities', { returnObjects: true })  as ISubAminity[];

    return (
        <div>
            <div>
                <section className='moreamenities-section'>
                    <div className="container">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="moreamenities-img">
                                    <img src={require('../../assets/images/moreamenities-img.jpg')} alt="img" className="img-fluid" />
                                </div>
                            </Col>
                            <Col md={6} className="ps-3">
                                <div className="moreamenities-heading">
                                    <h3 className="title"> {t('aminity.more_amenities')}</h3>
                                </div>
                                <div className="amenities-list">
                                    <ul>
                                        {aminities && aminities.length > 0 ?
                                            aminities.map((aminity: IAminityData, index: number) => (
                                                <li key={"More_Aminity_" + index}>{aminity_json && aminity_json.length>0 &&  aminity_json[0].title}</li>
                                            ))
                                            : <NoData message="Oops, No More Aminities Found!!" />}
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default AmenitiesSection2;